import MdDialogConfirm from "./MdDialogConfirm"

const MdDialogConfirmPlugin = {
  install(app) {
    app.component(MdDialogConfirm.name, MdDialogConfirm)
  },
}

export default MdDialogConfirmPlugin
